import {createAction} from "redux-actions";
import {BASIC_LOADING, BASIC_CLOSE_SNACKBAR, BASIC_OPEN_SNACKBAR, BASIC_ME, DRAW_INFO} from "../constants/store";

export const basic_set_loading = createAction(BASIC_LOADING);
export const basic_set_open_snackbar = createAction(BASIC_OPEN_SNACKBAR);
export const basic_set_close_snackbar = createAction(BASIC_CLOSE_SNACKBAR);
export const basic_set_me = createAction(BASIC_ME);
export const basic_set_draw_info = createAction(DRAW_INFO);